<div class="controls d-xs-none d-md-flex">
  <div
    class="name control"
    (click)="setSort('name')"
    [ngClass]="{ active: sorting.field === 'name' }">
    <span>Name</span>
  </div>

  <div
    class="status control d-xs-none d-md-block"
    (click)="setSort('status')"
    [ngClass]="{ active: sorting.field === 'status' }">
    <span>Status</span>
  </div>

  <div
    class="organization control d-xs-none d-md-block"
    (click)="setSort('organization')"
    [ngClass]="{ active: sorting.field === 'organization' }">
    <span>Organization</span>
  </div>

  <div
    class="role control d-xs-none d-md-block"
    (click)="setSort('role')"
    [ngClass]="{ active: sorting.field === 'role' }">
    <span>Role</span>
  </div>

  <div class="ideas control d-xs-none d-md-block">
    <span>Recent Contributions</span>
  </div>
</div>
